import script from "./BotMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./BotMessage.vue?vue&type=script&setup=true&lang=js"

import "./BotMessage.vue?vue&type=style&index=0&id=9f12a80a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f12a80a"]])

export default __exports__